import { Environment } from './models/environment.model';

export const environment: Environment = {
  envName: 'dev',
  production: false,
  languages: {
    en: true,
    pt: true,
  },
  urls: {
    frontend: {
      app: 'http://localhost:4200',
    },
    backend: {
      /** Ambiente de DEV do backend (fornecido pelo time de back). */
      gateway: 'https://api.dev.lumio.bet/api',
      api: 'https://api.dev.lumio.bet/api',
    },
  },
  /** Set your Google Client ID for local testing. Add http://localhost:4200 to Authorized JavaScript Origins. */
  googleClientId: '483554234059-2514b3pn4ili87mi4gm91iqavsjlp0bf.apps.googleusercontent.com',
  /** Cloudflare Turnstile (dev only). */
  captchaSiteKey: '0x4AAAAAACiFKOhhbJOtwooZ',
  iapProductId: 'bet.lumio.app.premium.monthly',
};
